module.exports = __webpack_public_path__ + "logo_small.svg?42fb676f62774cd66d4288cf049b214f";


//////////////////
// WEBPACK FOOTER
// ./src/assets/logo_small.svg
// module id = 338
// module chunks = 1